import { useState, useEffect, type MouseEvent as ReactMouseEvent } from "react";

const NAV_LINKS = [
  { label: "首页聚焦", anchor: "focus" },
  { label: "实时热榜", anchor: "trend" },
  { label: "后续追踪", anchor: "news" },
  { label: "时间线复盘", anchor: "timeline" },
  { label: "反转盘点", anchor: "reversal" },
  { label: "当事人回应", anchor: "response" },
  { label: "话题专区", anchor: "topic" },
  { label: "常见问题", anchor: "faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e: ReactMouseEvent<HTMLAnchorElement>, anchor: string) => {
    e.preventDefault();
    setOpen(false);
    document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="w-full bg-[#faf6ee]">
      {/* 顶栏日期条 */}
      <div className="hidden md:block border-b border-orange-900/10">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-2 text-xs text-stone-500">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line text-orange-700"></i>
              2026年9月6日 · 星期日
            </span>
            <span className="hidden lg:inline-flex items-center gap-1.5">
              <i className="ri-fire-line text-red-700"></i>
              今日全网热瓜已更新 6 起
            </span>
          </div>
          <a
            href="#subscribe"
            onClick={(e) => go(e, "subscribe")}
            className="flex items-center gap-1.5 text-red-700 hover:text-red-800 transition-colors"
          >
            <i className="ri-notification-3-line"></i>
            订阅推送提醒
          </a>
        </div>
      </div>

      {/* 刊头 Masthead */}
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-5">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-700 text-white">
            <i className="ri-fire-fill text-xl"></i>
          </div>
          <a href="#focus" onClick={(e) => go(e, "focus")} className="leading-none">
            <h1 className="font-masthead text-2xl font-black tracking-tight text-stone-900 md:text-[32px]">
              全网<span className="text-red-700">热瓜</span>
            </h1>
            <p className="mt-1 text-[11px] tracking-[0.28em] text-stone-400">全网热瓜 · 后续与最新进展</p>
          </a>
        </div>
        <div className="hidden items-center gap-2 lg:flex">
          <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-medium text-amber-900">
            <i className="ri-flashlight-fill mr-1 text-amber-600"></i>2 起事件正处于反转关键期
          </span>
          <a
            href="#subscribe"
            onClick={(e) => go(e, "subscribe")}
            className="whitespace-nowrap rounded-md bg-red-700 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-800"
          >
            订阅追踪进度
          </a>
        </div>
        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-orange-900/15 text-stone-700 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {/* 栏目导航（吸顶） */}
      <nav
        className={`sticky top-0 z-50 w-full border-t border-orange-900/10 bg-[#faf6ee] transition-colors ${
          scrolled ? "border-b border-orange-900/15" : ""
        }`}
      >
        <div className="mx-auto hidden max-w-7xl items-center gap-1 overflow-x-auto px-4 md:px-6 md:flex">
          {NAV_LINKS.map((l, i) => (
            <a
              key={l.anchor}
              href={`#${l.anchor}`}
              onClick={(e) => go(e, l.anchor)}
              className={`whitespace-nowrap px-4 py-3 text-sm transition-colors ${
                i === 0
                  ? "font-semibold text-red-700"
                  : "text-stone-600 hover:text-red-700"
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>
        {/* 移动端菜单 */}
        <div className={`md:hidden ${open ? "block" : "hidden"}`}>
          <div className="grid grid-cols-2 gap-1 px-4 pb-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.anchor}
                href={`#${l.anchor}`}
                onClick={(e) => go(e, l.anchor)}
                className="rounded-md bg-white px-3 py-2.5 text-sm text-stone-700"
              >
                {l.label}
              </a>
            ))}
          </div>
          <div className="px-4 pb-4">
            <a
              href="#subscribe"
              onClick={(e) => go(e, "subscribe")}
              className="flex items-center justify-center whitespace-nowrap rounded-md bg-red-700 px-4 py-2.5 text-sm font-medium text-white"
            >
              <i className="ri-notification-3-line mr-1.5"></i>订阅推送提醒
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}